'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsStacked = getIsStacked;

exports.default = function (type) {
    return chartTypeMap.get(type.toLowerCase()) || {
        type: type.toLowerCase()
    };
};

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: IE11 does not support passing the array directly to the constructor
var chartTypeMap = new Map();

chartTypeMap.set('radar', { type: 'line', polar: true });
chartTypeMap.set('gauge', { type: 'solidgauge' });
chartTypeMap.set('stackedcolumn', { type: 'column' });
chartTypeMap.set('stackedbar', { type: 'bar' });

var stackedTypes = ['stackedcolumn', 'stackedbar', 'area'];

function getIsStacked(type) {
    return (0, _arrayContains2.default)(stackedTypes, type.toLowerCase());
}
//# sourceMappingURL=type.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/type.js
 ** module id = 33
 ** module chunks = 0 1
 **/